export enum UserRoleType {
    Validator = 'Validator',
    Originator = 'Originator'
}
